
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* ブランド情報 */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              伝説のヘッドスパ
            </h3>
            <p className="text-gray-300 mb-3 sm:mb-4 text-sm sm:text-base">
              45年の経験と最新技術で、お客様の美と健康をサポートします。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* サービス */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">サービス</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#head-spa-services" 
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('head-spa-services')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base"
                >
                  ヘッドスパ
                </a>
              </li>
              <li>
                <a 
                  href="#head-spa-services" 
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('head-spa-services')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base"
                >
                  頭皮ケア
                </a>
              </li>
              <li>
                <a 
                  href="#head-spa-services" 
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('head-spa-services')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base"
                >
                  アーユルヴェーダ
                </a>
              </li>
              <li>
                <a 
                  href="#contact" 
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base"
                >
                  カウンセリング
                </a>
              </li>
            </ul>
          </div>

          {/* 会社情報 */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">会社情報</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#salon-info" 
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('salon-info')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base"
                >
                  会社概要
                </a>
              </li>
              <li>
                <a 
                  href="/salons" 
                  onClick={(e) => {
                    e.preventDefault();
                    window.REACT_APP_NAVIGATE('/salons');
                  }}
                  className="hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base"
                >
                  加盟サロン
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base">採用情報</a>
              </li>
              <li>
                <a href="#" className="hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base">プライバシーポリシー</a>
              </li>
            </ul>
          </div>

          {/* お問い合わせ */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">お問い合わせ</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-phone-line mr-2 sm:mr-3 text-amber-400 flex-shrink-0"></i>
                <span className="text-sm sm:text-base">0120-600-226</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2 sm:mr-3 text-amber-400 flex-shrink-0"></i>
                <span className="text-sm sm:text-base break-all">info@densetsu-spa.com</span>
              </div>
              <div className="flex items-start">
                <i className="ri-time-line mr-2 sm:mr-3 text-amber-400 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm sm:text-base">平日 10:00〜17:00</p>
                  <p className="text-xs sm:text-sm text-gray-400">土日祝日休み</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-xs sm:text-sm mb-4 sm:mb-0">
            © 2024 伝説のヘッドスパ. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-amber-400 transition-colors text-xs sm:text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
